export default __webpack_public_path__ + "static/media/Yang Shao.e9300f20.jpg";